var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loadComplete)?_c('div',[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view',{key:_vm.activeProjectId})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }